import React, { useEffect, useState } from 'react';
import { usePosting, useTitle } from '../../Hooks';
import { PostingWorker } from '../../Classes';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { Button, Header, Placeholder, Table } from 'react-frontier';
import { Card, Modal, InviteModal } from '../../components';
import { bindClick } from '@tempu/components/Util';
import { firstBy } from 'thenby';
import API, { CDN_URL } from '../../API';
import moment from 'moment';
import BusinessAccess from '../../BusinessAccess';

var PostingWorkers = ()=>{
	var navigate = useNavigate();
	var params = useParams<{ pid: string }>();
	var posting_id = parseInt(params?.pid);
	var { hasAccess } = usePosting(posting_id);
	var [workersList, setWorkersList] = useState<PostingWorker[]>(null);
	var { setTitle, setAction } = useTitle();
	var [loadError, setLoadError] = useState<string>(null);
	var [workerModal, setWorkerModal] = useState<boolean>(false);
	var [selectedWorker, setSelectedWorker] = useState<PostingWorker>(null);
	var [addWorkerModal, setAddWorkerModal] = useState<boolean>(false);

	useEffect(()=>{
		setTitle('Empleados');
		if(!params || !posting_id || Number.isNaN(posting_id)) return;

		
		if(hasAccess(BusinessAccess.ADMIN.ADD_USER)){
			setAction(
				<div style={{ display: 'flex' , gap: 5 }}>
					<Button icon color='black' iconName='file-download' onClick={downloadEmployees}/>
					<Button text='Invitar Usuario' iconName='plus-circle' color='black' onClick={bindClick(setAddWorkerModal, true)}/>
					<Button text='Invitaciónes' iconName='user-circle' color='black' as={Link} to={window.location.pathname.split('/').slice(0, -1).join('/') + '/invitations'}/>
				</div>
			);
		}

		API.getPostingUsers(posting_id, 1).then(res=>{
			if(res.error) return setLoadError(res.message);
			setWorkersList(res.data);
		}).catch(e=>{
			return setLoadError('Hubo un error inesperado cargando los empleados (LCL-1)');
		});
	}, []);

	var openWorkerModal = (worker: PostingWorker)=>{
		setSelectedWorker(worker);
		setWorkerModal(true);
	};

	var downloadEmployees = ()=>{
		API.downloadPostingEmployees(posting_id).then(res=>{	
		}).catch(err=>{
			setLoadError('Hubo un error inesperado descargando los empleados (LCL-1)');
		});
	}

	if(!hasAccess(BusinessAccess.POSTINGS.VIEW_POSTINGS)){
		return <Header text='Sin acceso' subtext='No tienes acceso a esta página' />
	}
	
	return <div className="tp posting-workers-screen">
		{loadError ? (
			<Header text='Error' subtext={loadError} />
		) : workersList ? (
			Object.entries(
				workersList
					.sort(firstBy('date_approved', 'desc').thenBy('date_created', 'asc'))
					.reduce((i, worker) => { (i[worker.job_name] ||= []).push(worker); return i }, {} as Record<string, typeof workersList>)
			).map(([jobName, workers]) => (
				<React.Fragment key={`JOB-${jobName}`}>
					<Header text={jobName} centered={false} style={{ marginTop: 15 }} size='small' />
					{workers.map(worker => (
						<Card
							className='worker'
							image={worker.image}
							imageFallbackIcon='image'
							key={`PSTWRK-${worker.user_id}`}
							onClick={() => openWorkerModal(worker)}
						>
							<div className="left">
								<div className="name">{`${worker.first_name} ${worker.last_name}`.toUpperCase()}</div>
								<div className="meta">Desde {moment.unix(worker.date_approved).format('DD/MMM/YY')}</div>
							</div>
							<div className="right">
								<div className="job-name">{worker.job_name}</div>
							</div>
						</Card>
					))}
				</React.Fragment>
			))
		) : (
			Array.from({ length: 3 }).map((_, i) => (
				<Card placeholder placeholderImage className='worker' key={`CRDPLH-${i}`}>
					<div className="left">
						<Placeholder />
						<Placeholder />
						<Placeholder />
					</div>
				</Card>
			))
		)}
		{workersList && workersList.length === 0 && <Header text='No existen empleados.' centered style={{ fontWeight: 'bold', marginTop: 15 }} />}
		<Modal open={workerModal} onClose={bindClick(setWorkerModal)} size='tiny'>
			<Modal.Header>Datos de empleado</Modal.Header>
			{selectedWorker && <Modal.Content>
				<Table
					details
				>
					<Table.Row data={['Nombre', `${(selectedWorker.first_name + ' ' + selectedWorker.last_name).toUpperCase()}`]}/>
					<Table.Row data={['Fecha de aplicación', moment.unix(selectedWorker.date_created).format('DD/MMM/YY')]}/>
					<Table.Row data={['Aprobo', selectedWorker.user_approved_name]}/>
					<Table.Row data={['Fecha de aprobación', moment.unix(selectedWorker.date_approved).format('DD/MMM/YY')]}/>
				</Table>
			</Modal.Content>}
			<Modal.Actions>
				<Button text='Cerrar' basic onClick={bindClick(setWorkerModal)} />
			</Modal.Actions>
		</Modal>
		<InviteModal
			open={addWorkerModal}
			onClose={bindClick(setAddWorkerModal)}
			posting_id={posting_id}
			onWorkerAdded={()=>setAddWorkerModal(false)}
		/>
	</div>
}

export default PostingWorkers;